export const enum FileType {
    Csv,
    Pdf,
    Xlsx,
    Zip,
}